import { useMemo } from "react"
import useSWRImmutable from "swr/immutable"
import { FaSpinner } from "react-icons/fa"

function StepNotice() {
  const { data: smeClientsCountData } = useSWRImmutable<{ totalCount: number }>(
    "/api/clients/sme-count"
  )
  const smeClientsCount = useMemo(
    () => smeClientsCountData?.totalCount ?? 0,
    [smeClientsCountData]
  )

  return (
    <div className="mb-3 text-lg font-semibold md:mb-4 md:text-2xl">
      지금
      {smeClientsCountData ? (
        <span className="font-bold">{smeClientsCount.toLocaleString()}명</span>
      ) : (
        <>
          <FaSpinner className="mx-1 inline-block animate-spin" />명
        </>
      )}
      의 소상공인이 이용중!
      <div className="text-lg font-semibold md:text-2xl">
        {"사업장 등록 완료 시 송장 용지를 지원해드립니다."}
      </div>
    </div>
  )
}

export default StepNotice
